import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { TableSecondary } from 'components/layout/Table'
import { Title } from 'components/layout'
import { assessorActivities as assessorLayout } from 'constants/layout/assessor'

export default class AssessorParticipantActivities extends Component {
  static propTypes = {
    activity: PropTypes.object
  }

  render() {
    const { activity } = this.props
    const hasMultiple =
      get(activity, 'allSectionActivitiesProgress') &&
      activity.allSectionActivitiesProgress.length > 1

    if (!hasMultiple) {
      return null
    }

    const completed = activity.allSectionActivitiesProgress.reduce(
      (sum = 0, value = 0) => sum + value.completed,
      0
    )

    return (
      <div className="base-margin--top">
        <Title
          h2
          className="omega"
          intlKey="moduleTitle.participant_activities"
        >
          Participant's activities
        </Title>
        <TableSecondary ths={assessorLayout.activitiesHeaders}>
          <tbody>
            {activity.allSectionActivitiesProgress.map((item = {}, index) => (
              <tr key={index}>
                <td>{item.activityCategoryName}</td>
                <td>
                  {item.completed / 3600} / {item.total / 3600}{' '}
                  <FormattedMessage
                    id="label.hours_first_letter"
                    defaultMessage="h"
                  />
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <strong>
                  <FormattedMessage id="table.total" defaultMessage="Total" />
                </strong>
              </td>
              <td>
                <strong>
                  {completed / 3600} /{' '}
                  {activity.allSectionActivitiesProgress[0].total / 3600}{' '}
                  <FormattedMessage
                    id="label.hours_first_letter"
                    defaultMessage="h"
                  />
                </strong>
              </td>
            </tr>
          </tbody>
        </TableSecondary>
      </div>
    )
  }
}
